import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const TransactionChart = ({ transactionData, title = "Transaction Distribution" }) => {
  if (!transactionData || transactionData.length === 0) {
    return (
      <div style={{
        padding: '20px',
        textAlign: 'center',
        color: '#666',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        Loading transaction data...
      </div>
    );
  }

  // Check if all transaction counts are 0
  const totalTransactions = transactionData.reduce((sum, item) => sum + (item.value || item.count || 0), 0);

  if (totalTransactions === 0) {
    return (
      <div style={{
        padding: '20px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '20px'
      }}>
        <h3 style={{
          marginTop: 0,
          marginBottom: 15,
          color: '#1976d2',
          fontSize: 16,
          fontWeight: 'bold',
          textAlign: 'center'
        }}>
          {title}
        </h3>
        <div style={{
          height: '300px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#666',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: 48,
            marginBottom: 16,
            opacity: 0.3
          }}>📊</div>
          <h4 style={{ margin: '0 0 8px 0', color: '#999' }}>No Transactions Today</h4>
          <p style={{ margin: 0, fontSize: 14, color: '#bbb' }}>
            Transaction data will appear here once payments are processed
          </p>
        </div>
      </div>
    );
  }

  const data = {
    labels: transactionData.map(item => item.name),
    datasets: [
      {
        data: transactionData.map(item => item.value || item.count),
        backgroundColor: transactionData.map(item => item.color) || [
          '#4BC0C0',
          '#FFCE56',
          '#FF6384',
        ],
        borderWidth: 2,
        borderColor: '#fff',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 20,
          usePointStyle: true,
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
  };

  return (
    <div style={{
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      marginBottom: '20px'
    }}>
      <h3 style={{ 
        marginTop: 0, 
        marginBottom: 15, 
        color: '#1976d2', 
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center'
      }}>
        {title}
      </h3>
      <div style={{ height: '300px', position: 'relative' }}>
        <Pie data={data} options={options} />
      </div>
    </div>
  );
};

export default TransactionChart;
